import * as React from 'react';

import { CURRENCIES } from 'src/features/payStations/types';

import type { VersionFormDisplayedValues } from 'src/features/reservations/types/reservationType';

type ReservationVersionsContextType = {
    displayedFormValues: VersionFormDisplayedValues;
    setDisplayedFormValues: React.Dispatch<React.SetStateAction<VersionFormDisplayedValues>>;
};

const ReservationVersionsContext = React.createContext<ReservationVersionsContextType | undefined>(undefined);

export const ReservationVersionsProvider = ({ children }: { children: React.ReactNode }) => {
    const [displayedFormValues, setDisplayedFormValues] = React.useState<VersionFormDisplayedValues>({
        price: '',
        tax_percent: '',
        tax_amount: '',
        price_with_tax: '',
        currency: CURRENCIES.EUR,
    });

    const value = React.useMemo(() => {
        return { displayedFormValues, setDisplayedFormValues };
    }, [displayedFormValues]);

    return <ReservationVersionsContext.Provider value={value}>{children}</ReservationVersionsContext.Provider>;
};

export const useDisplayedFormValues = (): ReservationVersionsContextType => {
    const context = React.useContext(ReservationVersionsContext);
    if (!context) {
        throw new Error('useDisplayedFormValues must be used within a ReservationVersionsContextProvider');
    }
    return context;
};
